import React from 'react';
import PropTypes from 'prop-types';
import { SERIES_TYPE_SERIES } from 'screens/SeriesDetail/SeriesDetailHelpers';

import Style from './Title.module.scss';

const Title = ({ seriesType, seriesName, episodeNumber, seasonNumber, name }) => {
  if (seriesType !== SERIES_TYPE_SERIES) return null;
  const seasonText = seasonNumber && `S${seasonNumber}`;
  const episodeText = episodeNumber && `E${episodeNumber}`;
  const nameText = name === seriesName ? '' : name;
  const tuneIn = [seasonText, episodeText, nameText].filter(text => text).join(' ');
  if (!tuneIn) return null;
  return <div className={Style.title}>{tuneIn}</div>;
};

Title.propTypes = {
  seriesType: PropTypes.string,
  seriesName: PropTypes.string,
  episodeNumber: PropTypes.number,
  seasonNumber: PropTypes.number,
  name: PropTypes.string,
};

export default Title;
